<template>
	<a-loading v-if="state === 'loading'" :name="$t('loading')" />
	<a-dialog v-else class="results-invoice">
		<div v-if="state === 'success'" class="results-invoice__box">
			<div v-html="$t('contactMe')"></div>
			<a-button
				:to="{ name: 'Results', params: { uuid } }"
				class="results-invoice__button"
			>
				{{ $t("successButton") }}
			</a-button>
		</div>
		<div v-else-if="state === 'notfound'" class="results-invoice__box">
			<h1 class="results-invoice__title">{{ $t("notfoundTitle") }}</h1>
			<p>{{ $t("notfoundBody") }}</p>
			<a-button
				:to="{ name: 'Results', params: { uuid } }"
				class="results-invoice__button"
			>
				{{ $t("notfoundButton") }}
			</a-button>
		</div>
		<div v-else class="results-invoice__box">
			<h1 class="results-invoice__title">{{ $t("errorTitle") }}</h1>
			<p>{{ $t("errorBody") }}</p>
			<p v-if="error">{{ error.message }}</p>
			<a-button class="results-invoice__button" @click="checkToken">
				{{ $t("errorButton") }}
			</a-button>
		</div>
	</a-dialog>
</template>

<script>
import aButton from "@/components/Button";
import aDialog from "@/components/Dialog";
import aLoading from "@/components/Loading";

export default {
	components: {
		aButton,
		aDialog,
		aLoading
	},
	props: {
		uuid: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			state: "loading",
			error: undefined
		};
	},
	i18n: {
		messages: {
			en: {
				successButton: "Go to your results",
				notfoundTitle: "Invoice expired",
				notfoundBody:
					"It seems like this URL has expired. Note that for security and privacy reasons, this link expires after one use, or after 2 months.",
				notfoundButton: "Go to your results",
				errorTitle: "An error happened",
				errorBody:
					"An unknown error happened when requesting your invoice!",
				errorButton: "Retry",
				loading: "Loading"
			},
			nl: {
				successTitle: "Bedankt!",
				successBody:
					"Eén van onze assetmanagement experts zal binnen drie werkdagen contact met je opnemen.",
				successButton: "Ga naar resultaten",
				loading: "Laden"
			}
		}
	},
	created() {
		this.checkToken();
	},
	methods: {
		checkToken() {
			this.state = "loading";
			this.error = undefined;
			fetch(`${process.env.API}/results/${this.uuid}/invoice`, {
				method: "POST",
				headers: {
					Accept: "application/json, text/plain, */*",
					"Content-Type": "application/json"
				},
				credentials: "same-origin",
				body: JSON.stringify(this.uuid)
			}).then(
				request => {
					if (request.ok) {
						this.state = "success";
					} else if (request.status === 404) {
						this.state = "notfound";
					} else {
						this.state = "error";
						this.error = new Error(`${request.status}`);
					}
				},
				error => {
					this.state = "error";
					this.error = error;
				}
			);
		}
	}
};
</script>

<style>
.results-invoice {
	max-width: 680px;
	font-size: 15px;
	font-family: Verdana, sans-serif;
}

.results-invoice__title {
	color: #0084a4;
	margin-bottom: 20px;
	font-size: 32px;
	font-family: TheSansOsF, sans-serif;
}

.results-invoice__button {
	margin-top: 8px;
}
</style>
